import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  name: string;
  role: string;
  age: string;
  location: string;
}
export function TestimonialCard({
  quote,
  name,
  role,
  age,
  location
}: TestimonialCardProps) {
  return <div className="bg-white p-8 rounded-2xl shadow-sm border border-stone-200 flex flex-col h-full" data-id="element-12">
      <div className="flex gap-1 mb-4" data-id="element-13">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-14" />)}
      </div>
      <blockquote className="text-stone-700 text-lg italic mb-6 flex-grow" data-id="element-15">
        "{quote}"
      </blockquote>
      <div className="mt-auto pt-4 border-t border-stone-100" data-id="element-16">
        <p className="font-bold text-stone-900" data-id="element-17">{name}</p>
        <p className="text-sm text-stone-500 mt-1" data-id="element-18">
          {role} · {age} años · {location}
        </p>
      </div>
    </div>;
}